import { render, staticRenderFns } from "./QuestionTypeFreeTextImage.vue?vue&type=template&id=d47a378a"
import script from "./QuestionTypeFreeTextImage.vue?vue&type=script&lang=js"
export * from "./QuestionTypeFreeTextImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports